import http from 'axios';
import download from 'downloadjs';
import axios from 'axios';
import { API_URL, FITTER_API_URL } from '../runtimeConfig';

const InvoicesService = () => {
    const getInvoices = async (page, pageSize) => {
        let url = API_URL + '/shop/invoices/?';

        if(page) {
            url += `&page=${page}&`;
        }
        if(pageSize) {
            url += `pageSize=${pageSize}&`;
        }
        
        try {
            const res = await http.get(url);
            
            // Map backend response (PascalCase) to frontend format (camelCase)
            const mappedData = {
                result: res.data.result || res.data.Result || [],
                pages: res.data.pages || res.data.Pages || [],
                page: res.data.page || res.data.Page || 1,
                pageSize: res.data.pageSize || res.data.PageSize || 30,
                totalCount: res.data.totalCount || res.data.TotalCount || 0,
                totalPages: res.data.totalPages || res.data.TotalPages || 0
            };
            
            return mappedData;
        } catch (err) {
            console.log(err);
            // Return base structure on error
            return { result: [], pages: [], page: 1, pageSize: 30, totalCount: 0, totalPages: 0 };
        }
    }

    // 
    const getInvoicePdf = async (invoiceId) => {
        const url = `${API_URL}/shop/invoices/${invoiceId}/pdfDocument/pdfDocumentContent`;

        try {
            const res = await http.get(url);
            const base64Response = res.data;
            const binary = atob(base64Response);
            const binaryData = [];
    
            for (let i = 0; i < binary.length; i++) {
                binaryData.push(binary.charCodeAt(i));
            }
    
            const blob = new Blob([new Uint8Array(binaryData)], { type: 'application/pdf' });
            download(blob, `invoice_${invoiceId}.pdf`);
        } catch (err) {
            console.log(err);
        }
    }

    const getPinkSheetSalesOrderName = async (orderId) => {
        let url = API_URL + `/pinkSheetSalesOrder/${orderId}`;

        try {
            const res = await http.get(url);
            return res.data;
        } catch (err) {
            console.log(err);
        }
    }

    // Calls the Fitter Global API to (re)generate the POD PDF for a sales
    // order. The endpoint returns the public blob URL of the generated PDF as
    // plain text. We use a fresh axios instance to bypass the eshop request
    // interceptor (which would attach an unrelated function key + bearer).
    const regeneratePinkSheet = async (orderNumber) => {
        if (!orderNumber) return null;
        const url = `${FITTER_API_URL}/orderPinksheet/${encodeURIComponent(orderNumber)}?force=true`;
        try {
            const res = await axios.post(url, null, {
                headers: { 'Content-Type': 'application/json' },
                responseType: 'text',
                transformResponse: [(d) => d],
            });
            return typeof res.data === 'string' ? res.data.trim() : null;
        } catch (err) {
            console.log('regeneratePinkSheet failed', err);
            return null;
        }
    };

    return { getInvoices, getInvoicePdf, getPinkSheetSalesOrderName, regeneratePinkSheet };

}

export default InvoicesService;